import * as i0 from '@angular/core';
import { Injectable, Component, Input, Output, Pipe, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import * as EventEmitter from 'events';
import * as i2 from 'primeng/api';
import { MessageService } from 'primeng/api';
import * as i3 from 'primeng/toast';
import { ToastModule } from 'primeng/toast';
import { CommonModule } from '@angular/common';

class NotificationService {
    constructor() {
        this.notificationsSource = new Subject();
        this.notifications$ = this.notificationsSource.asObservable();
    }
    push(notification) {
        this.notificationsSource.next(notification);
    }
}
NotificationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: NotificationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NotificationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: NotificationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: NotificationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class NotificationComponent {
    constructor(notificationService, messageService) {
        this.notificationService = notificationService;
        this.messageService = messageService;
        this.defaultLife = 12000;
        this.position = 'top-right';
        this.closed = new EventEmitter();
        this.notificationService.notifications$.subscribe(notification => {
            if (!notification.life || notification.life === 0 && !this.defaultLife) {
                notification.life = this.defaultLife;
            }
            messageService.add(notification);
        });
    }
}
NotificationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: NotificationComponent, deps: [{ token: NotificationService }, { token: i2.MessageService }], target: i0.ɵɵFactoryTarget.Component });
NotificationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: NotificationComponent, selector: "if-notification", inputs: { defaultLife: "defaultLife", position: "position" }, outputs: { closed: "closed" }, providers: [MessageService], ngImport: i0, template: `<p-toast [position]=position (onClose)='closed'></p-toast>`, isInline: true, components: [{ type: i3.Toast, selector: "p-toast", inputs: ["key", "autoZIndex", "baseZIndex", "style", "styleClass", "position", "preventOpenDuplicates", "preventDuplicates", "showTransformOptions", "hideTransformOptions", "showTransitionOptions", "hideTransitionOptions", "breakpoints"], outputs: ["onClose"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: NotificationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'if-notification',
                    template: `<p-toast [position]=position (onClose)='closed'></p-toast>`,
                    providers: [MessageService]
                }]
        }], ctorParameters: function () { return [{ type: NotificationService }, { type: i2.MessageService }]; }, propDecorators: { defaultLife: [{
                type: Input
            }], position: [{
                type: Input
            }], closed: [{
                type: Output
            }] } });

class AbstractControlToFormControlPipe {
    transform(value, ...args) {
        return value;
    }
}
AbstractControlToFormControlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: AbstractControlToFormControlPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
AbstractControlToFormControlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: AbstractControlToFormControlPipe, name: "AbstractControlToFormControl" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: AbstractControlToFormControlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'AbstractControlToFormControl'
                }]
        }] });

class IfAngularCoreModule {
}
IfAngularCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: IfAngularCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IfAngularCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: IfAngularCoreModule, declarations: [NotificationComponent, AbstractControlToFormControlPipe], imports: [ToastModule,
        CommonModule], exports: [NotificationComponent, AbstractControlToFormControlPipe] });
IfAngularCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: IfAngularCoreModule, imports: [[ToastModule,
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: IfAngularCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NotificationComponent, AbstractControlToFormControlPipe],
                    imports: [ToastModule,
                        CommonModule
                    ],
                    exports: [NotificationComponent, AbstractControlToFormControlPipe]
                }]
        }] });

/*
 * Public API Surface of if-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractControlToFormControlPipe, IfAngularCoreModule, NotificationComponent, NotificationService };
